import type { RejectionReason } from '../types/products.types';

export function formatRejectionReason(reason: RejectionReason): string {
    switch (reason.rule) {
        case 'max_vehicle_age_years':
            return `Vehicle age (${reason.actual} years) exceeds maximum of ${reason.threshold} years`;
        case 'max_entry_mileage':
            return `Mileage (${Number(reason.actual).toLocaleString()} miles) exceeds maximum of ${Number(reason.threshold).toLocaleString()} miles`;
        case 'eligible_fuel_types':
            return `Fuel type "${reason.actual}" is not eligible for this product`;
        case 'dealer_not_authorised':
            return 'This product is not available to your dealership';
        default:
            return `Eligibility rule "${reason.rule}" not met`;
    }
}
